import { Translation } from 'react-i18next';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { ColumnProps, BadgeAvatar } from '@/components';

import style from './index.module.scss';
import { OfficialBadge, UnionBadge } from '../../types';
import { IconRcTick } from '@/assets';

export const getColumns = (
  showBadgeIssuedInfo?: boolean,
): Array<ColumnProps<UnionBadge & { has_minted: boolean }>> => [
  {
    title: <Translation>{t => t('BadgeList_columns.122hkz')}</Translation>,
    width: '10%',
    key: 'logo_thumbnail_url',
    render: ({ row }) => {
      return <BadgeAvatar src={row.logo_thumbnail_url} width={38} className={style.badgeIcon} />;
    },
    skeleton: (
      <div className={style.innerCell}>
        <Skeleton width={32} circle />
      </div>
    ),
  },
  {
    title: <Translation>{t => t('BadgeList_columns.1fvl7')}</Translation>,
    key: 'name',
    width: '20%',
    render: ({ row, rowIndex }) => {
      const isOfficialBadge = (row as OfficialBadge)?.official_id;
      return (
        <div className={style.nameContainer}>
          <span className={style.badgeName}>{row.name}</span>
          {isOfficialBadge && showBadgeIssuedInfo && (
            <span className={style.issuedBy}>
              <Translation>{t => t('BadgeList_columns.107cxxo')}</Translation>
              {(row as OfficialBadge)?.official?.name}
            </span>
          )}
        </div>
      );
    },
    skeleton: (
      <div className={style.innerCell}>
        <Skeleton width={80} />
      </div>
    ),
  },
  {
    title: <Translation>{t => t('BadgeList_columns.description')}</Translation>,
    width: '50%',
    key: 'desc',
    render: ({ row }) => {
      return <div className={style.badgeDesc}>{row.desc}</div>;
    },
    skeleton: <Skeleton width={104} />,
  },
  {
    title: <Translation>{t => t('BadgeList_columns.a3rr3x')}</Translation>,
    width: '10%',
    key: 'total_minted',
    render: ({ row }) => {
      return <span className={style.badgeMintCount}>{row._total_supply}</span>;
    },
    align: 'center',
    skeleton: (
      <div className={style.innerCell}>
        <Skeleton width={20} />
      </div>
    ),
  },
  {
    title: <Translation>{t => t('BadgeList_columns.1247zq9')}</Translation>,
    width: '10%',
    align: 'center',
    key: 'minted',
    render: ({ row }) => {
      return row.has_minted ? (
        <IconRcTick className={style.mintedIcon} color="var(--color-green)" />
      ) : null;
    },
    skeleton: (
      <div className={style.innerCell}>
        <Skeleton width={20} />
      </div>
    ),
  },
];
